var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#FFF", fillRule: "evenodd", d: "M12 2c4.238 0 7.5 2.968 7.5 8 0 3.492-2.088 7.042-6.171 10.672a2 2 0 0 1-2.658 0C6.588 17.042 4.5 13.492 4.5 10c0-5.032 3.262-8 7.5-8zm0 2c-3.173 0-5.5 2.117-5.5 6 0 2.825 1.803 5.89 5.5 9.177 3.697-3.286 5.5-6.352 5.5-9.177 0-3.883-2.327-6-5.5-6zm0 7.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" })
  );
});